import React, { Component } from "react";
import Translation from "../translation/translation";
// import { Link, withRouter, Redirect } from 'react-router-dom';
// import $ from 'jquery';
import Context from "../context/context";
import Edit from "../controls/edit";
import Comm from "../comm/comm";
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class PackinglistData extends Component {
    DoBind() {
        this.Save = this.Save.bind(this);
        this.Cancel = this.Cancel.bind(this);
    }

    constructor(props) {
        super(props);
        this.DoBind();

        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            id: this.props.plid, // this.state.DisplayedPackingList
        };

        var result = Comm.GetPackingListData(data);

        this.state = {
            PL: result.data,
        };
        this.invoice_date = React.createRef();
        this.invoice_no = React.createRef();
        this.container_no = React.createRef();
        this.hs = React.createRef();
        this.trailer_reg_no = React.createRef();
        this.truck_reg_no = React.createRef();
    }

    Save() {
        var sid = Context.GetContext().Sid;
        var data = {
            invoice_date: moment(this.invoice_date.current.GetValue(), "DD.MM.YYYY").format("YYYYMMDD"),
            invoice_no: "",
            container_no: "",
            hs: "",
            trailer_reg_no: "",
            truck_reg_no: "",
        };
        if (this.invoice_no.current.GetValue()) data.invoice_no = this.invoice_no.current.GetValue();
        if (this.container_no.current.GetValue()) data.container_no = this.container_no.current.GetValue();
        if (this.hs.current.GetValue()) data.hs = this.hs.current.GetValue();
        if (this.trailer_reg_no.current.GetValue())
            data.trailer_reg_no = this.trailer_reg_no.current.GetValue();
        if (this.truck_reg_no.current.GetValue()) data.truck_reg_no = this.truck_reg_no.current.GetValue();
        var obj = {
            session: sid,
            id: this.props.plid,
            data: JSON.stringify(data),
        };
        //console.log("tosave", obj);
        const result = Comm.SetPackingListData(obj);
        if (result && result.code === 0) {
            this.props.updatePackingList();
        }
    }

    Cancel() {
        this.props.hidepagefunc();
    }

    render() {
        return (
            <div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("hs")}</label>
                    <Edit ref={this.hs} type="text" value={this.state.PL.hs} />
                </div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("truckregno")}</label>
                    <Edit ref={this.truck_reg_no} type="text" value={this.state.PL.truck_reg_no} />
                </div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("trailerregno")}</label>
                    <Edit ref={this.trailer_reg_no} type="text" value={this.state.PL.trailer_reg_no} />
                </div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("containerno")}</label>
                    <Edit ref={this.container_no} type="text" value={this.state.PL.container_no} />
                </div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("invoiceno")}</label>
                    <Edit ref={this.invoice_no} type="text" value={this.state.PL.invoice_no} />
                </div>
                <div className="col-md-12">
                    <label className="control-label">{Translation.Trans("invoicedate")}</label>
                    <Edit ref={this.invoice_date} type="date" value={this.state.PL.invoice_date} />
                </div>
                <div className="col-md-12">
                    <button className="btn btn-primary" onClick={() => this.Save()}>
                        <i className="fas fa-save"></i>
                        <p>{Translation.Trans("save")}</p>
                    </button>
                    <button className="btn btn-primary" onClick={() => this.Cancel()}>
                        <i className="fas fa-times-circle"></i>
                        <p>{Translation.Trans("cancel")}</p>
                    </button>
                </div>
            </div>
        );
    }
}

export default PackinglistData;



// WEBPACK FOOTER //
// ./src/controls/packinglistdata.js